<template>
<svg viewBox="0 0 12 12" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-dic`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.86761 0.875C8.87569 0.875 9.38004 0.875102 9.76508 1.07129C10.1035 1.24379 10.3787 1.51902 10.5512 1.85742C10.7474 2.24244 10.7475 2.74692 10.7475 3.75488V9.20703C10.7475 9.87909 10.7474 10.216 10.6166 10.4727C10.5016 10.6983 10.3179 10.8821 10.0922 10.9971C9.83556 11.1277 9.4994 11.1279 8.82758 11.1279H5.09222C3.7484 11.1279 3.07627 11.1277 2.56293 10.8662C2.11144 10.6362 1.74421 10.2688 1.5141 9.81738C1.25251 9.30399 1.25238 8.63124 1.25238 7.28711V4.71484C1.25238 3.37088 1.25253 2.6989 1.5141 2.18555C1.7442 1.73397 2.11135 1.36681 2.56293 1.13672C2.835 0.998113 3.15167 0.933942 3.58929 0.90332V4.84961L4.64398 4.24902L5.69867 4.84961V0.875H7.86761ZM3.40863 8.47363C3.11055 8.47393 2.86859 8.7165 2.86859 9.01465C2.8688 9.31262 3.11068 9.5544 3.40863 9.55469H8.59027C8.88847 9.55469 9.1301 9.3128 9.13031 9.01465C9.13031 8.71632 8.8886 8.47363 8.59027 8.47363H3.40863Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillDic',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
